module.exports = __webpack_public_path__ + "img/FULL_HD_VIDEO_COLPOSCOPE.836cae03.jpg";